import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { ISbStoryData } from "storyblok-js-client";
import { unref } from "vue";

import type { ISbStoriesParamsGeneric } from "~/types/Storyblok";
import { $fetchWithTimeout } from "~/utils/promiseWithTimeout";

export const storyblokQueryKeys = createQueryKeys("storyblok", {
  story: <C extends string = string>(
    slug: MaybeRef<string>,
    params: MaybeRef<ISbStoriesParamsGeneric<C>>,
    options: {
      useNitroEndpoint: boolean;
    },
  ) => {
    return {
      queryKey: [slug, params],
      queryFn: async () => {
        const unreffedSlug = unref(slug);
        const unreffedParams = unref(params);

        if (options.useNitroEndpoint) {
          const response = await $fetchWithTimeout<ISbStoryData | "not-found">(
            `/api/cdn/stories/${unreffedSlug}`,
            {
              method: "GET",
              params: unreffedParams,
            },
          );

          if (response === "not-found") return null;

          return response;
        }

        const storyblokApiInstance = useStoryblokApi();

        const { data } = await storyblokApiInstance.get(
          `cdn/stories/${unreffedSlug}`,
          unreffedParams,
        );

        return data.story;
      },
    };
  },
});
